<template>
  <div class="funfacts-area ptb-100">
    <div class="container">
      <div class="section-title text-center">
        <span class="sub-title">Resultados Comprovados</span>
        <h2>Empresas que usam HawkCRM crescem mais rápido</h2>
        <p>Dados reais de clientes que transformaram seus negócios com nossa plataforma</p>
      </div>

      <!-- Estatísticas Principais -->
      <div class="stats-grid">
        <div
            v-for="(stat, index) in stats"
            :key="stat.id"
            class="stat-card"
            data-aos="fade-up"
            :data-aos-delay="index * 100"
        >
          <div class="stat-icon">
            <i :class="stat.icon"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-number">{{ stat.number }}</h3>
            <p class="stat-label">{{ stat.label }}</p>
            <span class="stat-description">{{ stat.description }}</span>
          </div>
        </div>
      </div>

      <!-- Benefícios em Destaque -->
      <div class="benefits-section" data-aos="fade-up" data-aos-delay="400">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <div class="benefits-content">
              <h3>Por que empresas escolhem HawkCRM?</h3>
              <div class="benefits-list">
                <div
                    v-for="benefit in benefits"
                    :key="benefit.id"
                    class="benefit-item"
                >
                  <div class="benefit-icon">
                    <i :class="benefit.icon"></i>
                  </div>
                  <div class="benefit-text">
                    <h4>{{ benefit.title }}</h4>
                    <p>{{ benefit.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="benefits-visual">
              <div class="visual-card card-1">
                <i class="ph-trend-up"></i>
                <div>
                  <span class="visual-number">+347%</span>
                  <span class="visual-label">ROI Médio</span>
                </div>
              </div>
              <div class="visual-card card-2">
                <i class="ph-clock"></i>
                <div>
                  <span class="visual-number">-65%</span>
                  <span class="visual-label">Tempo em Tarefas</span>
                </div>
              </div>
              <div class="visual-card card-3">
                <i class="ph-users-three"></i>
                <div>
                  <span class="visual-number">+89%</span>
                  <span class="visual-label">Satisfação do Cliente</span>
                </div>
              </div>
              <div class="center-badge">
                <div class="badge-content">
                  <i class="ph-trophy"></i>
                  <span>Self-Hosted</span>
                  <strong>100% Seus Dados</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Depoimento em Destaque -->
      <div class="testimonial-highlight" data-aos="fade-up">
        <div class="testimonial-content">
          <i class="ph-quotes"></i>
          <p class="testimonial-text">
            "Desde que implementamos o HawkCRM, nossa taxa de conversão aumentou 95% e
            conseguimos reduzir o tempo de fechamento de vendas pela metade. A melhor
            decisão que tomamos para nosso time comercial."
          </p>
          <div class="testimonial-author">
            <div class="author-avatar">
              <i class="ph-user-circle"></i>
            </div>
            <div class="author-info">
              <strong>Anderson Martins</strong>
              <span>Diretor Comercial, All In Solução</span>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA Final -->
      <div class="funfacts-cta text-center" data-aos="fade-up">
        <h3>Pronto para transformar seu negócio?</h3>
        <p>Agende uma demonstração personalizada e veja o HawkCRM em ação</p>
        <a href="https://wa.me/5554992302401?text=Quero agendar uma demonstração do HawkCRM"
           target="_blank"
           class="btn-style-one green-color"
           rel="noopener noreferrer">
          Agendar Demonstração Gratuita
          <i class="ph-caret-right"></i>
        </a>
      </div>
    </div>

    <!-- Background Elements -->
    <div class="bg-decoration">
      <div class="decoration-circle circle-1"></div>
      <div class="decoration-circle circle-2"></div>
      <div class="decoration-circle circle-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Funfacts',
  data() {
    return {
      stats: [
        {
          id: 1,
          icon: 'ph-chart-line-up',
          number: '+347%',
          label: 'Aumento em Vendas',
          description: 'ROI médio em 12 meses'
        },
        {
          id: 2,
          icon: 'ph-users-three',
          number: '10+',
          label: 'Empresas Ativas',
          description: 'Confiando no HawkCRM'
        },
        {
          id: 3,
          icon: 'ph-handshake',
          number: '150k+',
          label: 'Negócios Fechados',
          description: 'Através da plataforma'
        },
        {
          id: 4,
          icon: 'ph-trophy',
          number: '98%',
          label: 'Taxa de Satisfação',
          description: 'Clientes muito satisfeitos'
        },
        {
          id: 5,
          icon: 'ph-clock',
          number: '-65%',
          label: 'Redução de Tempo',
          description: 'Em tarefas manuais'
        },
        {
          id: 6,
          icon: 'ph-shield-check',
          number: '100%',
          label: 'Dados Seguros',
          description: 'Self-hosted no seu servidor'
        }
      ],
      benefits: [
        {
          id: 1,
          icon: 'ph-lightning',
          title: 'Implementação Rápida',
          description: 'Configure e comece a usar em menos de 24 horas'
        },
        {
          id: 2,
          icon: 'ph-globe',
          title: 'Acesso de Qualquer Lugar',
          description: 'Web, mobile e desktop - trabalhe de onde estiver'
        },
        {
          id: 3,
          icon: 'ph-lock-key',
          title: 'Controle Total',
          description: 'Seus dados no seu servidor, sem mensalidades eternas'
        },
        {
          id: 4,
          icon: 'ph-users',
          title: 'Suporte Dedicado',
          description: 'Equipe especializada sempre disponível'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* ===== AREA BASE ===== */
.funfacts-area {
  background: linear-gradient(180deg, #f9f9f9 0%, #ffffff 100%);
  position: relative;
  overflow: hidden;
}

/* ===== STATS GRID ===== */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin: 60px 0 80px;
}

.stat-card {
  background: white;
  padding: 35px 30px;
  border-radius: 16px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: flex-start;
  gap: 20px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.stat-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-color: #6D5DFC;
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, rgba(109, 93, 252, 0.1) 0%, rgba(67, 97, 238, 0.1) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon i {
  font-size: 32px;
  color: #6D5DFC;
}

.stat-content {
  flex: 1;
}

.stat-number {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 5px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 5px;
  display: block;
}

.stat-description {
  font-size: 13px;
  color: #666;
}

/* ===== BENEFITS SECTION ===== */
.benefits-section {
  margin-bottom: 80px;
}

.benefits-content h3 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 30px;
  color: #1a1a1a;
}

.benefits-list {
  display: grid;
  gap: 25px;
}

.benefit-item {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.benefit-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.benefit-icon i {
  font-size: 26px;
  color: white;
}

.benefit-text h4 {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 8px;
  color: #1a1a1a;
}

.benefit-text p {
  font-size: 15px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

/* ===== BENEFITS VISUAL ===== */
.benefits-visual {
  position: relative;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.visual-card {
  position: absolute;
  background: white;
  padding: 20px 25px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 15px;
  border: 2px solid #6D5DFC;
  animation: float 3s ease-in-out infinite;
}

.visual-card i {
  font-size: 32px;
  color: #6D5DFC;
}

.visual-card div {
  display: flex;
  flex-direction: column;
}

.visual-number {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
}

.visual-label {
  font-size: 12px;
  color: #666;
}

.card-1 {
  top: 10%;
  left: 5%;
  animation-delay: 0s;
}

.card-2 {
  top: 50%;
  right: 10%;
  animation-delay: 1s;
}

.card-3 {
  bottom: 15%;
  left: 10%;
  animation-delay: 2s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
}

.center-badge {
  width: 180px;
  height: 180px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 15px 40px rgba(109, 93, 252, 0.3);
}

.badge-content {
  text-align: center;
  color: white;
}

.badge-content i {
  font-size: 40px;
  margin-bottom: 10px;
  display: block;
}

.badge-content span {
  font-size: 12px;
  display: block;
  margin-bottom: 5px;
  opacity: 0.9;
}

.badge-content strong {
  font-size: 14px;
  font-weight: 700;
  display: block;
}

/* ===== TESTIMONIAL ===== */
.testimonial-highlight {
  background: linear-gradient(135deg, rgba(109, 93, 252, 0.05) 0%, rgba(67, 97, 238, 0.05) 100%);
  padding: 50px;
  border-radius: 20px;
  border: 2px solid rgba(109, 93, 252, 0.1);
  margin-bottom: 60px;
}

.testimonial-content {
  position: relative;
}

.testimonial-content > i {
  font-size: 60px;
  color: rgba(109, 93, 252, 0.2);
  position: absolute;
  top: -20px;
  left: -10px;
}

.testimonial-text {
  font-size: 20px;
  line-height: 1.7;
  color: #333;
  font-style: italic;
  margin: 0 0 30px;
  padding-left: 60px;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-left: 60px;
}

.author-avatar {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.author-avatar i {
  font-size: 36px;
  color: white;
}

.author-info strong {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 5px;
}

.author-info span {
  font-size: 14px;
  color: #666;
}

/* ===== CTA ===== */
.funfacts-cta h3 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #1a1a1a;
}

.funfacts-cta p {
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}

.btn-style-one {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 15px 35px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: white;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid #25D366;
}

.btn-style-one:hover {
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.5);
  color: white;
}

/* ===== BACKGROUND ===== */
.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.decoration-circle {
  position: absolute;
  border-radius: 50%;
  border: 2px solid rgba(109, 93, 252, 0.1);
  animation: rotateCircle 20s linear infinite;
}

.circle-1 {
  width: 400px;
  height: 400px;
  top: -200px;
  right: -200px;
}

.circle-2 {
  width: 300px;
  height: 300px;
  bottom: -150px;
  left: -150px;
  animation-delay: 5s;
}

.circle-3 {
  width: 200px;
  height: 200px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 10s;
}

@keyframes rotateCircle {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 991px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .benefits-content {
    margin-bottom: 50px;
  }

  .benefits-visual {
    min-height: 300px;
  }

  .visual-card {
    padding: 15px 20px;
  }

  .center-badge {
    width: 140px;
    height: 140px;
  }

  .testimonial-text {
    font-size: 18px;
    padding-left: 40px;
  }

  .testimonial-author {
    padding-left: 40px;
  }
}

@media (max-width: 576px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 25px 20px;
  }

  .stat-number {
    font-size: 28px;
  }

  .visual-card {
    display: none;
  }

  .center-badge {
    position: static;
  }

  .testimonial-highlight {
    padding: 30px 20px;
  }

  .testimonial-text {
    font-size: 16px;
    padding-left: 0;
  }

  .testimonial-author {
    padding-left: 0;
  }

  .funfacts-cta h3 {
    font-size: 24px;
  }
}
</style>